import { ApiService } from "./ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export interface SubCategory {
  subClassId: string;
  subClassName: string;
  categoryId: string | null;
}

export interface BookCategory {
  categoryId: string;
  categoryName: string;
  subClasses: SubCategory[];
}

export const CategoryApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getListOfCategories: builder.query<any[], void>({
      query: () => ({
        url: `/categories`,
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<any[]>) => res.results ?? [],
    }),

    getBooksCategory: builder.query<BookCategory[], void>({
      query: () => ({
        url: `/categories/books/`,
        method: "GET",
        headers: {
          origin: "AlphabitEcommerce.0.1",
        },
      }),
      transformResponse: (response: ResultsDTO<BookCategory[]>) =>
        response.results ?? [],
    }),
  }),
});

export const { useGetListOfCategoriesQuery, useGetBooksCategoryQuery } =
  CategoryApiSlice;
